import { ErrorMessagesInterface } from '../interfaces/error-message.interface';

export const SIGNUP_FORM_ERROR_MESSAGES: ErrorMessagesInterface = {
  firstName: {
    required: 'signUpPage.validationErrors.firstName.required',
    minLength: 'signUpPage.validationErrors.firstName.minLength',
    maxLength: 'signUpPage.validationErrors.firstName.maxLength',
    pattern: 'signUpPage.validationErrors.firstName.pattern',
  },
  lastName: {
    required: 'signUpPage.validationErrors.lastName.required',
    minLength: 'signUpPage.validationErrors.lastName.minLength',
    maxLength: 'signUpPage.validationErrors.lastName.maxLength',
    pattern: 'signUpPage.validationErrors.lastName.pattern',
  },
  email: {
    required: 'signUpPage.validationErrors.email.required',
    pattern: 'signUpPage.validationErrors.email.pattern',
  },
  password: {
    required: 'signUpPage.validationErrors.password.required',
    minLength: 'signUpPage.validationErrors.password.minLength',
    maxLength: 'signUpPage.validationErrors.password.maxLength',
    noSpaces: 'signUpPage.validationErrors.password.noSpaces',
    pattern: 'signUpPage.validationErrors.password.pattern',
  },
  confirmPassword: {
    required: 'signUpPage.validationErrors.confirmPassword.required',
    missMatch: 'signUpPage.validationErrors.confirmPassword.missMatch',
  },
  repeatPassword: {
    required: 'signUpPage.validationErrors.repeatPassword.required',
  },
  termsAccepted: {
    required: 'signUpPage.validationErrors.termsAccepted.required',
  },
};
